import gql from 'graphql-tag'

export const CatalogProductsColumns = gql`
  query CatalogProductsColumns {
    catalogProductsColumns {
      column_name
      column_type
    }
  }
`